import { connect } from 'react-redux';
import { useInView } from 'react-intersection-observer';
import { FooterLocalizationLink } from './footer-localization-link';
import TraderaSymbol from '@tradera/blueprint/theme/logos/tradera_symbol.svg?jsx';

import {
    BuyingLinks,
    SellingLinks,
    ContactAndHelpLinks,
    InformationLinks,
    SocialLinks
} from './footer-links';
import { FooterPartners } from './footer-partners';

import styles from './site-footer.module.scss';
import { FooterCurrencyLink } from './footer-currency-link';
import { AppDownloadBanner } from 'tradera/apps/tradera/components/app-download-banner/app-download-banner';
import PAGE_TYPES from 'tradera/constants/page-types';
import { SiteWidth } from 'tradera/components/site-width/site-width';
import { StartPageFooterBanner } from 'tradera/components/site-footer/start-page-footer-banner';

const SiteFooter = ({ pageType }) => {
    const [symbolRef, inView] = useInView({
        threshold: 0
    });

    if (pageType === PAGE_TYPES.MY_MESSAGES_PAGE) {
        return null;
    }

    const showAppDownloadBanner = pageType === 'StartPage';

    return (
        <div
            className={`${styles.siteFooter} d-hybrid-none bg-branded text-styled`}>
            {showAppDownloadBanner && <AppDownloadBanner />}
            <StartPageFooterBanner />
            <div className="position-relative">
                <SiteWidth className="d-flex flex-column pt-4">
                    <div className={styles.wrapper}>
                        <div className="row px-2 px-md-3 px-lg-2">
                            {/* Köp */}
                            <BuyingLinks />

                            {/* Sälj */}
                            <SellingLinks />
                            {/* Kontakt & hjälp */}
                            <ContactAndHelpLinks />
                            {/* Information */}
                            <InformationLinks />
                        </div>
                        <div className="px-2 px-md-3 px-lg-2 row">
                            <FooterLocalizationLink className="mr-4 col-12 col-md-auto text-inter-light" />
                            <FooterCurrencyLink className="col-12 col-md-auto text-inter-light" />
                        </div>
                        <div className="row mx-2 mx-md-3 mx-lg-2">
                            <SocialLinks />
                        </div>
                        <div
                            className={`${styles.logosRow} row mx-2 mx-md-3 mx-lg-2 mb-1`}>
                            <FooterPartners />
                        </div>
                        {/* Copyright */}
                        <div className="row px-2 px-md-3 px-lg-2">
                            <p className="col-12 mb-5 text-no-wrap">
                                © {new Date().getFullYear()} Tradera
                            </p>
                        </div>
                    </div>
                </SiteWidth>
                <div className={styles.symbol} ref={symbolRef}>
                    {/* Required to render inline with this ID for Item Card fallback referencing this SVG with <use /> */}
                    <TraderaSymbol
                        id="tradera-symbol"
                        className={`${styles.logo} ${
                            inView ? styles.playAnimation : ''
                        }`}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = (state) => ({
    pageType: state.page.type
});

export default connect(mapStateToProps)(SiteFooter);
